(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/views/drawselector_list.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/views/drawselector_list.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.sport=_svs.sport||{};
_svs.sport.drawselector=_svs.sport.drawselector||{};
_svs.sport.drawselector.templates=_svs.sport.drawselector.templates||{};
svs.sport.drawselector.templates.drawselector_list = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li class=\"list-group-item draw-selector "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isCurrentDraw") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":4,"column":53},"end":{"line":4,"column":214}}})) != null ? stack1 : "")
    + "\" data-drawnum="
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"drawNumber") || (depth0 != null ? lookupProperty(depth0,"drawNumber") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"drawNumber","hash":{},"data":data,"loc":{"start":{"line":4,"column":229},"end":{"line":4,"column":243}}}) : helper)))
    + ">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"components-sport-drawselector-drawselector_item"),depth0,{"name":"components-sport-drawselector-drawselector_item","data":data,"indent":"              ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "            </li>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "drawselector-current-round";
},"4":function(container,depth0,helpers,partials,data) {
    return "js-change-round clickable clickable-list-group-item-default js-clickable js-clickable-delayed-click";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"panel panel-default panel-drawselector\" id=\"draw-selector\">\n    <ul class=\"list-group\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"items") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":7,"column":17}}})) != null ? stack1 : "")
    + "    </ul>\n</div>\n";
},"usePartial":true,"useData":true});
Handlebars.partials['components-sport-drawselector-drawselector_list'] = svs.sport.drawselector.templates.drawselector_list;
})(svs, Handlebars);


 })(window);